import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { Box, Button, Tooltip } from '@customerio/pluma-components/react';
import { PlumaSideNav as PlumaSideNavCss } from '@customerio/pluma-components/css/components';
import { toggleDevHelper, $isDevHelperOpen } from '@/layouts/root/components/dev-helper/store';
import { useStore } from '@nanostores/react';
import * as styles from './wrapper.css';

type DevToolsNavButtonProps = {
  sideNavRef: React.RefObject<HTMLElement | null>;
  isCollapsible: boolean;
};

export function DevToolsNavButton({ sideNavRef, isCollapsible }: DevToolsNavButtonProps) {
  const [footerElement, setFooterElement] = useState<Element | null>(null);
  const isDevHelperOpen = useStore($isDevHelperOpen);

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- existing effect pattern before this rule was enforced strictly; avoid adding new cases
    if (sideNavRef.current != null) {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state -- existing effect pattern before this rule was enforced strictly; avoid adding new cases
      setFooterElement(sideNavRef.current.querySelector(`.${PlumaSideNavCss.classNames.sideNavFooter}`));
    }
  }, [sideNavRef, isCollapsible]);

  const button = (
    <Tooltip isCustom={true} content="Developer tools" placement="right">
      {(tooltipContext) => (
        <Button
          {...tooltipContext.reference.getReferenceProps({
            onClick: () => toggleDevHelper(),
          })}
          ref={tooltipContext.reference.setReference}
          icon="skills"
          isActive={isDevHelperOpen}
          isIconOnly={true}
          variant="subtle"
          aria-label="Developer tools"
          className={styles.devToolsToggle}
        />
      )}
    </Tooltip>
  );

  if (footerElement != null) {
    return createPortal(button, footerElement);
  }

  return <Box pb="100">{button}</Box>;
}
